import { createSlice } from "@reduxjs/toolkit";

 export const ThemeSlice = createSlice({
    name:"theme",
    initialState:"white",
    reducers:{
        changeTheme :(state)=>state=="light"?"dark":"light"
    },
 });
 export const  { changeTheme} = ThemeSlice.actions;
 export default ThemeSlice.reducer;
